"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowsToken = exports.AdskToken = void 0;
const superstruct_1 = require("superstruct");
exports.AdskToken = (0, superstruct_1.type)({
    iss: (0, superstruct_1.refine)((0, superstruct_1.string)(), "Autodesk issuer", (value) => {
        try {
            const { hostname } = new URL(value);
            return /\.autodesk\.com$/.test(hostname);
        }
        catch (_a) {
            return false;
        }
    }),
    userid: (0, superstruct_1.string)(),
});
exports.WindowsToken = (0, superstruct_1.type)({
    iss: (0, superstruct_1.refine)((0, superstruct_1.string)(), "Microsoft issuer", (value) => {
        try {
            const { hostname } = new URL(value);
            return /\.windows\.net$/.test(hostname);
        }
        catch (_a) {
            return false;
        }
    }),
    email: (0, superstruct_1.string)(),
});
